var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit-user-profile-form',{attrs:{"profile":_vm.profile,"state":_vm.state,"change-password-state":_vm.state,"submitting":_vm.submitting,"active-tab":_vm.activeTab},on:{"submit":_vm.onUpdateProfile,"change-password":_vm.onChangePassword}})}
var staticRenderFns = []

export { render, staticRenderFns }